"use strict";
// Contracts for /v1/admins/org-setting/auto-ack.
//
// The feature auto-ASKS for acknowledgement: when one of `events` fires, the
// users matched by `userCriteria` are asked to acknowledge the new message.
Object.defineProperty(exports, "__esModule", { value: true });
